import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.filter.js";
import debounce from "../utils/debounce.js";
var aggBucketSize = 1000;
var scrollToEdges = ['start', 'center', 'end', 'start-force', 'center-force', 'end-force'];
var slice = Array.prototype.slice;
var buggyRTL = void 0; // mobile Chrome takes the crown for this

function detectBuggyRTL() {
  var scroller = document.createElement('div');
  var spacer = document.createElement('div');
  scroller.setAttribute('dir', 'rtl');
  scroller.style.width = '1px';
  scroller.style.height = '1px';
  scroller.style.overflow = 'auto';
  spacer.style.width = '1000px';
  spacer.style.height = '1px';
  document.body.appendChild(scroller);
  scroller.appendChild(spacer);
  scroller.scrollLeft = -1000;
  buggyRTL = scroller.scrollLeft >= 0;
  scroller.remove();
}

function sumFn(acc, h) {
  return acc + h;
}

function getScrollDetails(parent, child, beforeRef, afterRef, horizontal, rtl, stickyStart, stickyEnd) {
  var parentCalc = parent === window ? document.scrollingElement || document.documentElement : parent,
      propElSize = horizontal === true ? 'offsetWidth' : 'offsetHeight',
      details = {
    scrollStart: 0,
    scrollViewSize: -stickyStart - stickyEnd,
    scrollMaxSize: 0,
    offsetStart: -stickyStart,
    offsetEnd: -stickyEnd
  };

  if (horizontal === true) {
    if (parent === window) {
      details.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0;
      details.scrollViewSize += window.innerWidth;
    } else {
      details.scrollStart = parentCalc.scrollLeft;
      details.scrollViewSize += parentCalc.clientWidth;
    }

    details.scrollMaxSize = parentCalc.scrollWidth;

    if (rtl === true) {
      details.scrollStart = (buggyRTL === true ? details.scrollMaxSize - details.scrollViewSize : 0) - details.scrollStart;
    }
  } else {
    if (parent === window) {
      details.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
      details.scrollViewSize += window.innerHeight;
    } else {
      details.scrollStart = parentCalc.scrollTop;
      details.scrollViewSize += parentCalc.clientHeight;
    }

    details.scrollMaxSize = parentCalc.scrollHeight;
  }

  if (beforeRef !== void 0) {
    for (var el = beforeRef.previousElementSibling; el !== null; el = el.previousElementSibling) {
      if (el.classList.contains('q-virtual-scroll--skip') === false) {
        details.offsetStart += el[propElSize];
      }
    }
  }

  if (afterRef !== void 0) {
    for (var _el = afterRef.nextElementSibling; _el !== null; _el = _el.nextElementSibling) {
      if (_el.classList.contains('q-virtual-scroll--skip') === false) {
        details.offsetEnd += _el[propElSize];
      }
    }
  }

  if (child !== parent) {
    var parentRect = parentCalc.getBoundingClientRect(),
        childRect = child.getBoundingClientRect();

    if (horizontal === true) {
      details.offsetStart += childRect.left - parentRect.left;
      details.offsetEnd -= childRect.width;
    } else {
      details.offsetStart += childRect.top - parentRect.top;
      details.offsetEnd -= childRect.height;
    }

    if (parent !== window) {
      details.offsetStart += details.scrollStart;
    }

    details.offsetEnd += details.scrollMaxSize - details.offsetStart;
  }

  return details;
}

function setScroll(parent, scroll, horizontal, rtl) {
  if (parent === window) {
    if (horizontal === true) {
      if (rtl === true) {
        scroll = (buggyRTL === true ? document.body.scrollWidth - window.innerWidth : 0) - scroll;
      }

      window.scrollTo(scroll, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    } else {
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, scroll);
    }
  } else if (horizontal === true) {
    if (rtl === true) {
      scroll = (buggyRTL === true ? parent.scrollWidth - parent.offsetWidth : 0) - scroll;
    }

    parent.scrollLeft = scroll;
  } else {
    parent.scrollTop = scroll;
  }
}

function sumSize(sizeAgg, size, from, to) {
  if (from >= to) {
    return 0;
  }

  var lastTo = size.length,
      fromAgg = Math.floor(from / aggBucketSize),
      toAgg = Math.floor((to - 1) / aggBucketSize) + 1;
  var total = sizeAgg.slice(fromAgg, toAgg).reduce(sumFn, 0);

  if (from % aggBucketSize !== 0) {
    total -= size.slice(fromAgg * aggBucketSize, from).reduce(sumFn, 0);
  }

  if (to % aggBucketSize !== 0 && to !== lastTo) {
    total -= size.slice(to, toAgg * aggBucketSize).reduce(sumFn, 0);
  }

  return total;
}

var commonVirtScrollProps = {
  virtualScrollSliceSize: {
    type: [Number, String],
    default: null
  },
  virtualScrollSliceRatioBefore: {
    type: [Number, String],
    default: 1
  },
  virtualScrollSliceRatioAfter: {
    type: [Number, String],
    default: 1
  },
  virtualScrollItemSize: {
    type: [Number, String],
    default: 24
  },
  virtualScrollStickySizeStart: {
    type: [Number, String],
    default: 0
  },
  virtualScrollStickySizeEnd: {
    type: [Number, String],
    default: 0
  },
  tableColspan: [Number, String]
};
var id = 1;

function setOverflowAnchor(id, index) {
  if (setOverflowAnchor.isSupported === void 0) {
    setOverflowAnchor.isSupported = window.getComputedStyle(document.body).overflowAnchor !== void 0;
  }

  if (setOverflowAnchor.isSupported === false) {
    return;
  }

  var ssId = id + '_ss';
  var styleSheet = document.getElementById(ssId);

  if (styleSheet === null) {
    styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.id = ssId;
    document.head.appendChild(styleSheet);
  }

  if (styleSheet.qChildIndex !== index) {
    styleSheet.qChildIndex = index;
    styleSheet.innerHTML = "#".concat(id, " > *:nth-child(").concat(index, ") { overflow-anchor: auto }");
  }
}

export var commonVirtPropsList = Object.keys(commonVirtScrollProps);
export default {
  props: _objectSpread({
    virtualScrollHorizontal: Boolean
  }, commonVirtScrollProps),
  data: function data() {
    return {
      virtualScrollSliceRange: {
        from: 0,
        to: 0
      },
      id: 'qvs_' + id++
    };
  },
  watch: {
    needsSliceRecalc: function needsSliceRecalc() {
      this.__setVirtualScrollSize();
    },
    needsReset: function needsReset() {
      this.reset();
    }
  },
  computed: {
    needsReset: function needsReset() {
      var _this = this;

      return ['virtualScrollItemSizeComputed', 'virtualScrollHorizontal'].map(function (p) {
        return _this[p];
      }).join(';');
    },
    needsSliceRecalc: function needsSliceRecalc() {
      var _this2 = this;

      return this.needsReset + ';' + ['virtualScrollSliceRatioBefore', 'virtualScrollSliceRatioAfter'].map(function (p) {
        return _this2[p];
      }).join(';');
    },
    colspanAttr: function colspanAttr() {
      return this.tableColspan !== void 0 ? {
        colspan: this.tableColspan
      } : {
        colspan: 100
      };
    },
    virtualScrollItemSizeComputed: function virtualScrollItemSizeComputed() {
      return this.virtualScrollItemSize;
    }
  },
  methods: {
    reset: function reset() {
      this.__resetVirtualScroll(this.prevToIndex, true);
    },
    refresh: function refresh(toIndex) {
      this.__resetVirtualScroll(toIndex === void 0 ? this.prevToIndex : toIndex);
    },
    scrollTo: function scrollTo(toIndex, edge) {
      var scrollEl = this.__getVirtualScrollTarget();

      if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
        return;
      }

      var scrollDetails = getScrollDetails(scrollEl, this.__getVirtualScrollEl(), this.$refs.before, this.$refs.after, this.virtualScrollHorizontal, this.$q.lang.rtl, this.virtualScrollStickySizeStart, this.virtualScrollStickySizeEnd);
      this.__scrollViewSize !== scrollDetails.scrollViewSize && this.__setVirtualScrollSize(scrollDetails.scrollViewSize);

      this.__setVirtualScrollSliceRange(scrollEl, scrollDetails, Math.min(this.virtualScrollLength - 1, Math.max(0, parseInt(toIndex, 10) || 0)), 0, scrollToEdges.indexOf(edge) > -1 ? edge : this.prevToIndex > -1 && toIndex > this.prevToIndex ? 'end' : 'start');
    },
    __onVirtualScrollEvt: function __onVirtualScrollEvt() {
      var scrollEl = this.__getVirtualScrollTarget();

      if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
        return;
      }

      var scrollDetails = getScrollDetails(scrollEl, this.__getVirtualScrollEl(), this.$refs.before, this.$refs.after, this.virtualScrollHorizontal, this.$q.lang.rtl, this.virtualScrollStickySizeStart, this.virtualScrollStickySizeEnd),
          listLastIndex = this.virtualScrollLength - 1,
          listEndOffset = scrollDetails.scrollMaxSize - scrollDetails.offsetStart - scrollDetails.offsetEnd - this.virtualScrollPaddingAfter;

      if (this.prevScrollStart === scrollDetails.scrollStart) {
        return;
      }

      if (scrollDetails.scrollMaxSize <= 0) {
        this.__setVirtualScrollSliceRange(scrollEl, scrollDetails, 0, 0);

        return;
      }

      this.__scrollViewSize !== scrollDetails.scrollViewSize && this.__setVirtualScrollSize(scrollDetails.scrollViewSize);

      this.__updateVirtualScrollSizes(this.virtualScrollSliceRange.from);

      var scrollMaxStart = Math.floor(scrollDetails.scrollMaxSize - Math.max(scrollDetails.scrollViewSize, scrollDetails.offsetEnd) - Math.min(this.virtualScrollSizes[listLastIndex], scrollDetails.scrollViewSize / 2));

      if (scrollMaxStart > 0 && Math.ceil(scrollDetails.scrollStart) >= scrollMaxStart) {
        this.__setVirtualScrollSliceRange(scrollEl, scrollDetails, listLastIndex, scrollDetails.scrollMaxSize - scrollDetails.offsetEnd - this.virtualScrollSizesAgg.reduce(sumFn, 0));

        return;
      }

      var toIndex = 0,
          listOffset = scrollDetails.scrollStart - scrollDetails.offsetStart,
          offset = listOffset;

      if (listOffset <= listEndOffset && listOffset + scrollDetails.scrollViewSize >= this.virtualScrollPaddingBefore) {
        listOffset -= this.virtualScrollPaddingBefore;
        toIndex = this.virtualScrollSliceRange.from;
        offset = listOffset;
      } else {
        for (var j = 0; listOffset >= this.virtualScrollSizesAgg[j] && toIndex < listLastIndex; j++) {
          listOffset -= this.virtualScrollSizesAgg[j];
          toIndex += aggBucketSize;
        }
      }

      while (listOffset > 0 && toIndex < listLastIndex) {
        listOffset -= this.virtualScrollSizes[toIndex];

        if (listOffset > -scrollDetails.scrollViewSize) {
          toIndex++;
          offset = listOffset;
        } else {
          offset = this.virtualScrollSizes[toIndex] + listOffset;
        }
      }

      this.__setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset);
    },
    __setVirtualScrollSliceRange: function __setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset, align) {
      var _this3 = this;

      var alignForce = typeof align === 'string' && align.indexOf('-force') > -1;
      var alignEnd = alignForce === true ? align.replace('-force', '') : align;
      var alignRange = alignEnd !== void 0 ? alignEnd : 'start';
      var from = Math.max(0, toIndex - this.virtualScrollSliceSizeComputed[alignRange]),
          to = from + this.virtualScrollSliceSizeComputed.total;

      if (to > this.virtualScrollLength) {
        to = this.virtualScrollLength;
        from = Math.max(0, to - this.virtualScrollSliceSizeComputed.total);
      }

      this.prevScrollStart = scrollDetails.scrollStart;
      var rangeChanged = from !== this.virtualScrollSliceRange.from || to !== this.virtualScrollSliceRange.to;

      if (rangeChanged === false && alignEnd === void 0) {
        this.__emitScroll(toIndex);

        return;
      }

      var _document = document,
          activeElement = _document.activeElement;

      if (rangeChanged === true && this.$refs.content !== void 0 && this.$refs.content !== activeElement && this.$refs.content.contains(activeElement) === true) {
        var onBlurFn = function onBlurFn() {
          _this3.$refs.content.focus();
        };

        activeElement.addEventListener('blur', onBlurFn, true);
        requestAnimationFrame(function () {
          activeElement.removeEventListener('blur', onBlurFn, true);
        });
      }

      setOverflowAnchor(this.id, toIndex - from + 1);
      var sizeBefore = alignEnd !== void 0 ? this.virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0) : 0;

      if (rangeChanged === true) {
        // vue key matching algorithm works only if
        // the array of VNodes changes on only one of the ends
        // so we first change one end and then the other
        var tempTo = to >= this.virtualScrollSliceRange.from && from <= this.virtualScrollSliceRange.to ? this.virtualScrollSliceRange.to : to;
        this.virtualScrollSliceRange = {
          from: from,
          to: tempTo
        };
        this.virtualScrollPaddingBefore = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, 0, from);
        this.virtualScrollPaddingAfter = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, this.virtualScrollSliceRange.to, this.virtualScrollLength);
        requestAnimationFrame(function () {
          if (_this3.virtualScrollSliceRange.to !== to && _this3.prevScrollStart === scrollDetails.scrollStart) {
            _this3.virtualScrollSliceRange = {
              from: _this3.virtualScrollSliceRange.from,
              to: to
            };
            _this3.virtualScrollPaddingAfter = sumSize(_this3.virtualScrollSizesAgg, _this3.virtualScrollSizes, to, _this3.virtualScrollLength);
          }
        });
      }

      requestAnimationFrame(function () {
        // if the scroll was changed give up
        // (another call to __setVirtualScrollSliceRange before animation frame)
        if (_this3.prevScrollStart !== scrollDetails.scrollStart) {
          return;
        }

        if (rangeChanged === true) {
          _this3.__updateVirtualScrollSizes(from);
        }

        var sizeAfter = _this3.virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0),
            posStart = sizeAfter + scrollDetails.offsetStart + _this3.virtualScrollPaddingBefore,
            posEnd = posStart + _this3.virtualScrollSizes[toIndex];

        var scrollPosition = posStart + offset;

        if (alignEnd !== void 0) {
          var sizeDiff = sizeAfter - sizeBefore;
          var scrollStart = scrollDetails.scrollStart + sizeDiff;
          scrollPosition = alignForce !== true && scrollStart < posStart && posEnd < scrollStart + scrollDetails.scrollViewSize ? scrollStart : alignEnd === 'end' ? posEnd - scrollDetails.scrollViewSize : posStart - (alignEnd === 'start' ? 0 : Math.round((scrollDetails.scrollViewSize - _this3.virtualScrollSizes[toIndex]) / 2));
        }

        _this3.prevScrollStart = scrollPosition;
        setScroll(scrollEl, scrollPosition, _this3.virtualScrollHorizontal, _this3.$q.lang.rtl);

        _this3.__emitScroll(toIndex);
      });
    },
    __updateVirtualScrollSizes: function __updateVirtualScrollSizes(from) {
      var contentEl = this.$refs.content;

      if (contentEl !== void 0) {
        var children = slice.call(contentEl.children).filter(function (el) {
          return el.classList.contains('q-virtual-scroll--skip') === false;
        }),
            childrenLength = children.length,
            sizeFn = this.virtualScrollHorizontal === true ? function (el) {
          return el.getBoundingClientRect().width;
        } : function (el) {
          return el.offsetHeight;
        };
        var index = from,
            size,
            diff;

        for (var i = 0; i < childrenLength;) {
          size = sizeFn(children[i]);
          i++;

          while (i < childrenLength && children[i].classList.contains('q-virtual-scroll--with-prev') === true) {
            size += sizeFn(children[i]);
            i++;
          }

          diff = size - this.virtualScrollSizes[index];

          if (diff !== 0) {
            this.virtualScrollSizes[index] += diff;
            this.virtualScrollSizesAgg[Math.floor(index / aggBucketSize)] += diff;
          }

          index++;
        }
      }
    },
    __resetVirtualScroll: function __resetVirtualScroll(toIndex, fullReset) {
      var _this4 = this;

      var defaultSize = 1 * this.virtualScrollItemSizeComputed;

      if (fullReset === true || Array.isArray(this.virtualScrollSizes) === false) {
        this.virtualScrollSizes = [];
      }

      var oldVirtualScrollSizesLength = this.virtualScrollSizes.length;
      this.virtualScrollSizes.length = this.virtualScrollLength;

      for (var i = this.virtualScrollLength - 1; i >= oldVirtualScrollSizesLength; i--) {
        this.virtualScrollSizes[i] = defaultSize;
      }

      var jMax = Math.floor((this.virtualScrollLength - 1) / aggBucketSize);
      this.virtualScrollSizesAgg = [];

      for (var j = 0; j <= jMax; j++) {
        var size = 0;
        var iMax = Math.min((j + 1) * aggBucketSize, this.virtualScrollLength);

        for (var _i = j * aggBucketSize; _i < iMax; _i++) {
          size += this.virtualScrollSizes[_i];
        }

        this.virtualScrollSizesAgg.push(size);
      }

      this.prevToIndex = -1;
      this.prevScrollStart = void 0;

      if (toIndex >= 0) {
        this.__updateVirtualScrollSizes(this.virtualScrollSliceRange.from);

        this.$nextTick(function () {
          _this4.scrollTo(toIndex);
        });
      } else {
        this.virtualScrollPaddingBefore = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, 0, this.virtualScrollSliceRange.from);
        this.virtualScrollPaddingAfter = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, this.virtualScrollSliceRange.to, this.virtualScrollLength);

        this.__onVirtualScrollEvt();
      }
    },
    __setVirtualScrollSize: function __setVirtualScrollSize(scrollViewSize) {
      if (scrollViewSize === void 0 && typeof window !== 'undefined') {
        var scrollEl = this.__getVirtualScrollTarget();

        if (scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
          scrollViewSize = getScrollDetails(scrollEl, this.__getVirtualScrollEl(), this.$refs.before, this.$refs.after, this.virtualScrollHorizontal, this.$q.lang.rtl, this.virtualScrollStickySizeStart, this.virtualScrollStickySizeEnd).scrollViewSize;
        }
      }

      this.__scrollViewSize = scrollViewSize;
      var multiplier = 1 + this.virtualScrollSliceRatioBefore + this.virtualScrollSliceRatioAfter;
      var view = scrollViewSize === void 0 || scrollViewSize <= 0 ? 1 : Math.ceil(scrollViewSize / this.virtualScrollItemSizeComputed);
      var baseSize = Math.max(10, view, Math.ceil(this.virtualScrollSliceSize / multiplier));
      this.virtualScrollSliceSizeComputed = {
        total: Math.ceil(baseSize * multiplier),
        start: Math.ceil(baseSize * this.virtualScrollSliceRatioBefore),
        center: Math.ceil(baseSize * (0.5 + this.virtualScrollSliceRatioBefore)),
        end: Math.ceil(baseSize * (1 + this.virtualScrollSliceRatioBefore)),
        view: view
      };
    },
    __padVirtualScroll: function __padVirtualScroll(h, tag, content) {
      var paddingSize = this.virtualScrollHorizontal === true ? 'width' : 'height';

      var style = _defineProperty({}, '--q-virtual-scroll-item-' + paddingSize, this.virtualScrollItemSizeComputed + 'px');

      return [tag === 'tbody' ? h(tag, {
        staticClass: 'q-virtual-scroll__padding',
        key: 'before',
        ref: 'before'
      }, [h('tr', [h('td', {
        style: _objectSpread(_defineProperty({}, paddingSize, "".concat(this.virtualScrollPaddingBefore, "px")), style),
        attrs: this.colspanAttr
      })])]) : h(tag, {
        staticClass: 'q-virtual-scroll__padding',
        key: 'before',
        ref: 'before',
        style: _objectSpread(_defineProperty({}, paddingSize, "".concat(this.virtualScrollPaddingBefore, "px")), style)
      }), h(tag, {
        staticClass: 'q-virtual-scroll__content',
        key: 'content',
        ref: 'content',
        attrs: {
          id: this.id,
          tabindex: -1
        }
      }, content), tag === 'tbody' ? h(tag, {
        staticClass: 'q-virtual-scroll__padding',
        key: 'after',
        ref: 'after'
      }, [h('tr', [h('td', {
        style: _objectSpread(_defineProperty({}, paddingSize, "".concat(this.virtualScrollPaddingAfter, "px")), style),
        attrs: this.colspanAttr
      })])]) : h(tag, {
        staticClass: 'q-virtual-scroll__padding',
        key: 'after',
        ref: 'after',
        style: _objectSpread(_defineProperty({}, paddingSize, "".concat(this.virtualScrollPaddingAfter, "px")), style)
      })];
    },
    __emitScroll: function __emitScroll(index) {
      if (this.prevToIndex !== index) {
        this.qListeners['virtual-scroll'] !== void 0 && this.$emit('virtual-scroll', {
          index: index,
          from: this.virtualScrollSliceRange.from,
          to: this.virtualScrollSliceRange.to - 1,
          direction: index < this.prevToIndex ? 'decrease' : 'increase',
          ref: this
        });
        this.prevToIndex = index;
      }
    }
  },
  created: function created() {
    this.__setVirtualScrollSize();
  },
  beforeMount: function beforeMount() {
    buggyRTL === void 0 && detectBuggyRTL();
    this.__onVirtualScrollEvt = debounce(this.__onVirtualScrollEvt, this.$q.platform.is.ios === true ? 120 : 35);

    this.__setVirtualScrollSize();
  },
  beforeDestroy: function beforeDestroy() {
    var styleSheet = document.getElementById(this.id + '_ss');
    styleSheet !== null && styleSheet.remove();
  }
};